import { reactive, toRefs, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useCurrentRoute } from './useCurrentRoute'
import { getParam } from '@/utils/url'
import request from '@/utils/request'
import { Toast } from 'vant'

export interface FormType {
  username: string
  password: string
  loading: boolean
  checked: boolean
}

export const useSigninEffect = () => {
  const store = useStore()
  const router = useRouter()

  const { redirect } = useCurrentRoute()
  const form = reactive<FormType>({
    username: '',
    password: '',
    loading: false,
    checked: false
  })
  const checkedShaky = ref(false)
  const onSubmit = () => {
    const param = getParam('param')
    let { checked } = form
    if (param && checked) {
      request({
        url: '/wxapp/xd/user/getSchoolLoginUrl',
        method: 'GET',
        params: {
          param: param
        }
      }).then(res => {
        if (res.status) {
          window.location.href = res.data as string
        } else {
          Toast({
            message: '若无法跳转到小程序，请确认是否关注服务号',
            position: 'top'
          })
        }
      })
    }
    if (!checked) {
      Toast({
        message: '请同意绑定微信作为学校管理内部使用',
        position: 'bottom'
      })
      checkedShaky.value = true
      setTimeout(() => {
        checkedShaky.value = false
      }, 2000)
    }
  }
  return { ...toRefs(form), onSubmit, checkedShaky }
}
